/**
 * Converts a string with spaces to camelCase
 * @param str The input string to convert
 * @returns The string in camelCase format
 * @example toCamelCase("hello world") // "helloWorld"
 * @example toCamelCase("Most Popular") // "mostPopular"
 */
export const toCamelCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '');
};

export function parseCapitalizeString(str: string | null | undefined) {
  if (!str) {
    return '';
  }
  // regex match beginning letter and first letter after space
  return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}

/**
 * Processes a string by replacing special characters with spaces and removing apostrophes
 * @param str The input string to process
 * @returns The processed string with special characters replaced
 */
export const processSpecialCharacters = (str: string): string => {
  return str
    .replace(/&/g, ' And ')
    .replace(/\//g, ' ')
    .replace(/-/g, ' ')
    .replace(/:/g, ' ') // Treat colons as spaces to avoid i18next namespace splitting
    .replace(/\(/g, ' ')
    .replace(/\)/g, ' ')
    .replace(/'/g, '');
};

/**
 * Converts a processed string into a translation key format by capitalizing words and joining them
 * @param str The processed string to convert
 * @returns The string in translation key format
 */
export const convertToTranslationKey = (str: string): string => {
  return str
    .split(/\s+/g)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};

export const formatMimeTypeToExtension = (
  mimeType: string | null | undefined
): string => {
  if (!mimeType) return '-';
  const parts = mimeType.split('/');
  const secondPart = parts[1];
  if (parts.length === 2 && secondPart) {
    const subtypeParts = secondPart.split(';');
    const subtype = (subtypeParts[0] ?? secondPart).trim();
    if (subtype.includes('vnd.ms-excel')) return 'xls';
    // cspell:ignore spreadsheetml wordprocessingml msword
    if (subtype.includes('spreadsheetml')) return 'xlsx';
    if (subtype.includes('wordprocessingml')) return 'docx';
    if (subtype.includes('msword')) return 'doc';
    if (subtype.includes('mpeg')) return 'mp3';
    return subtype;
  }
  return '-';
};
